import { render, staticRenderFns } from "./EditPersonnel.vue?vue&type=template&id=4de7ecb6&scoped=true&"
import script from "./EditPersonnel.vue?vue&type=script&lang=js&"
export * from "./EditPersonnel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4de7ecb6",
  null
  
)

export default component.exports